module.exports = __webpack_public_path__ + "static/fonts/element-icons.732389de.ttf";